import React from "react";
import { ArrowLeft } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import BusinessFooter from "./BusinessFooter";

export default function LegalPage({ title, description, effectiveDate, children }) {
  return (
    <div className="min-h-screen bg-[#111] font-maple text-gray-300">
      <Helmet>
        <title>{title} - Disparty</title>
        <meta name="description" content={description || `${title} 안내`} />
      </Helmet>

      <main className="mx-auto w-full max-w-4xl px-5 py-10 sm:px-8 sm:py-14">
        <Link
          to="/ko"
          className="inline-flex items-center gap-2 text-sm text-gray-400 transition-colors hover:text-white"
        >
          <ArrowLeft className="h-4 w-4" /> Disparty로 돌아가기
        </Link>
        <header className="mt-8 border-b border-gray-800 pb-7">
          <h1 className="text-3xl font-normal text-white sm:text-4xl">{title}</h1>
          {description && <p className="mt-3 text-sm leading-6 text-gray-400">{description}</p>}
          <p className="mt-4 text-xs text-gray-600">시행일 {effectiveDate}</p>
        </header>

        <article className="legal-document py-8 text-sm leading-7 text-gray-300 sm:text-[15px]">
          {children}
        </article>
      </main>
      <BusinessFooter locale="ko" />
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section className="mb-9 border-b border-gray-800 pb-8 last:border-b-0">
      <h2 className="mb-3 text-lg font-normal text-white">{title}</h2>
      <div className="space-y-3 whitespace-pre-line text-gray-400">{children}</div>
    </section>
  );
}
